import { useCallback } from 'react';
import { useResetAtom } from 'jotai/utils';
import { loaderState, userInfoAtom } from '@/data/atoms/utilsAtoms';
import { reactionTableLimitAtom, userReactionAtom } from '@/data/atoms/reactionAtom';
import { accessStatusAtom, trcUserAtom } from '@/TRC/atoms/trc-global';

export const useResetAllAtoms = () => {
	const resetUserInfo = useResetAtom(userInfoAtom);
	const resetLoaderState = useResetAtom(loaderState);
	const resetUserReactions = useResetAtom(userReactionAtom);
	const resetReactionTableLimit = useResetAtom(reactionTableLimitAtom);
	const resetAccessStatus = useResetAtom(accessStatusAtom);
	const resetTrcUser = useResetAtom(trcUserAtom);

	return useCallback(() => {
		resetUserInfo();
		resetLoaderState();
		resetUserReactions();
		resetReactionTableLimit();
		resetAccessStatus();
		resetTrcUser();
	}, [
		resetAccessStatus,
		resetLoaderState,
		resetReactionTableLimit,
		resetTrcUser,
		resetUserInfo,
		resetUserReactions
	]);
};
